module.exports = __webpack_public_path__ + "static/img/99611ef423117ea891312a664778958d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index_img4.png
// module id = kgfK
// module chunks = 1